module.exports = __webpack_public_path__ + "img/footer-2_en.9a61bbb.jpg";